import * as s from "./website-content.scss";
import {
    Component
} from "../../../../../sedestral/framework/interface/component/Component";
import {NetworkVendor} from "../../../../../network/NetworkVendor";
import {WebsiteBlackBlockComponent} from "../black/block/WebsiteBlackBlockComponent";
import {Resources} from "../../../../../resources/Resources";
import {
    WebsiteBlackTestimonialPresentationComponent
} from "../black/testimonial/presentation/WebsiteBlackTestimonialPresentationComponent";
import {WebsiteBlackReviewComponent} from "../black/review/WebsiteBlackReviewComponent";
import {WebsiteBlackUnionLineComponent} from "../black/union/line/WebsiteBlackUnionLineComponent";
import {
    WebsiteBlackTestimonialResultsComponent
} from "../black/testimonial/results/WebsiteBlackTestimonialResultsComponent";
import {Network} from "../../../../../network/Network";

export class WebsiteContentTestimonialBetComponent extends Component {
    constructor() {
        super();
        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteContent}">
                <div class="${s.content}">
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackTestimonialPresentationComponent({
                            title: Resources.t("words.testimonialSeoBoostBetThermique"),
                            stats: [
                                {value: "+90%", label: Resources.t("words.testimonialSeoKeywords")},
                                {value: "+483%", label: Resources.t("words.testimonialSeoClicksSixMonths")},
                                {value: "+52%", label: Resources.t("words.testimonialSeoImpressionsSixMonths")}
                            ],
                            customerName: "Bet-Thermique",
                            customerDescription: Resources.t("words.testimonialBetThermiqueDescription"),
                            customerImage: NetworkVendor.image("customer-bet.webp")
                        }))}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackReviewComponent({
                            name: "Vincent Coralie",
                            role: Resources.t("words.ceoBetThermique"),
                            review: Resources.t("words.testimonialReviewVincentCoralie"),
                            noStars: true,
                            color: "white",
                            title: Resources.t("words.testimonialCustomerTitle"),
                            tiny: true,
                        }))}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackUnionLineComponent("white"))}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackBlockComponent({
                            text: Resources.t("words.testimonialCtaQuestion"),
                            color: "black",
                            buttons: [
                                {
                                    name: Resources.t("words.testimonialRequestDemo"),
                                    color: "black",
                                    link: Network.router.pages.getUrlWithPath('schedule')
                                },
                                {
                                    name: Resources.t("words.testimonialTryFree"),
                                    link: Network.router.pages.getPanelUrl('signup')
                                }
                            ]
                        }))}
                    </div>
                </div>
                <div class="${s.white}">
                    <div class="${s.content}">
                        <div class="${s.container}">
                            ${this.draw(new WebsiteBlackTestimonialResultsComponent([
                                {
                                    title: Resources.t("words.testimonialClicksTitle"),
                                    image: NetworkVendor.image("customer-bet-clics.webp"),
                                    description: Resources.t("words.testimonialClicksDescription")
                                },
                                {
                                    title: Resources.t("words.testimonialKeywordsTitle"),
                                    image: NetworkVendor.image("customer-bet-keywords.webp"),
                                    description: Resources.t("words.testimonialKeywordsDescription")
                                },
                                {
                                    title: Resources.t("words.testimonialImpressionsTitle"),
                                    image: NetworkVendor.image("customer-bet-impressions.webp"),
                                    description: Resources.t("words.testimonialImpressionsDescription")
                                }
                            ]))}
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}
